/** HBoxContainer registration: parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseHBoxContainer } from './parser';
const hBoxContainerRegistration = {
    typeName: 'HBoxContainer',
    parser: parseHBoxContainer,
};
nodeRegistry.register(hBoxContainerRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map